
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/beginners-guide/breeding-guide",
      function () {
        return require("private-next-pages/battle-demo/beginners-guide/breeding-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/beginners-guide/breeding-guide"])
      });
    }
  